import { CleanHands } from "@mui/icons-material";
import { ReduxThunkAction } from "../..";
import { formatDateToYYYYMMDD } from "../../../../shared/util/formatDates";
import {
    generateExcelFile,
    readEchometerFile,
    readExcelFile,
    readSiamFile,
} from "../../../../shared/util/functions";
import { formatDateWithoutTimeZone } from "../../../../shared/util/times";
import {
    FileCustom,
    PendingUploadInfo,
} from "../../../../tecnica/modules/consolidate_files/interfaces";
import { config } from "../../configVar";
import { gerenciaTecnicaSlice, mainSlice } from "../index";
import { ListOfLocationsToAnalyst } from "./interfaces";

// const serverUrl = window.location.hostname === 'localhost' ? 'http://localhost:3335' : 'https://api.field-data-lake.com';
// const serverUrl = 'https://api.well-whisper.com'
// const serverUrl = 'https://api.field-data-lake.com'
// const serverUrl = 'http://localhost:3335'
const serverUrl = config.serverUrl;

const allowLogOut = false;

export const createTaskWithFiles =
    (props: PendingUploadInfo): ReduxThunkAction =>
        async (dispatch, getState) => {
            try {
                // const serverUrl = process.env.NEXT_PUBLIC_BACK_HOST

                let token = localStorage.getItem("authToken");

                if (!token) {
                    dispatch(mainSlice.actions.setUploadingStep("Error Uploading"));
                    return;
                }

                dispatch(mainSlice.actions.setUploadingStep("Creating Task"));

                const response = await fetch(`${serverUrl}/api/tasks/createTask`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `${token}`,
                    },
                    body: JSON.stringify({
                        taskId: props.taskId,
                        sprintId: props.sprintId,
                        type: props.type,
                        teamMembersId: props.teamMembersIds,
                        totalFiles: props.totalFiles,
                    }),
                });

                const taskCreated = await response.json();

                if (response?.status === 401 && allowLogOut) {
                    localStorage.removeItem("authToken");
                    dispatch(
                        mainSlice.actions.addToastNotification({
                            id: `${mainSlice.actions.addToastNotification.length + 1
                                }`,
                            message:
                                "Token ha expirado, por favor inicia sesión nuevamente",
                            type: "error",
                            duration: 5000,
                        })
                    );
                    dispatch(mainSlice.actions.activeUser());
                    return;
                }

                if (response?.status !== 200 && response?.status !== 201) {
                    console.log("Error");
                    dispatch(mainSlice.actions.setUploadingStep("Error Uploading"));
                    return;
                }

                const sortedFiles = props?.selectedFiles?.sort((a, b) => {
                    const excelMimeType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

                    if (a.fileType === excelMimeType) {
                        return -1;
                    } else if (
                        a.fileType !== excelMimeType &&
                        b.fileType === excelMimeType
                    ) {
                        return 1;
                    }
                    return 2;
                });

                for (const element of sortedFiles || []) {
                    dispatch(
                        mainSlice.actions.setUploadingStep(
                            `Uploading File ${element.fileName}`
                        )
                    );

                    const formData = new FormData();
                    formData.append("file", element.file);

                    const headers = {
                        authorization: `${token}`,
                        taskId: taskCreated.id,
                    };

                    const response = await fetch(
                        `${serverUrl}/api/tasks/uploadFileToTask`,
                        {
                            method: "POST",
                            headers,
                            body: formData,
                        }
                    );

                    if (response?.status === 401 && allowLogOut) {
                        localStorage.removeItem("authToken");
                        dispatch(
                            mainSlice.actions.addToastNotification({
                                id: `${mainSlice.actions.addToastNotification.length +
                                    1
                                    }`,
                                message:
                                    "Token ha expirado, por favor inicia sesión nuevamente",
                                type: "error",
                                duration: 5000,
                            })
                        );
                        dispatch(mainSlice.actions.activeUser());
                        return;
                    }

                    if (response?.status !== 200 && response?.status !== 201) {
                        console.log("Error");
                        dispatch(
                            mainSlice.actions.setUploadingStep(`Error Uploading`)
                        );
                        return;
                    }
                }

                dispatch(mainSlice.actions.setUploadingStep(`Task Uploaded`));
            } catch (error) {
                console.log({ error });
            } finally {
                dispatch(mainSlice.actions.updateState({ status: false }));
            }
        };

export const getTaskList =
    (page = 0, limit = 100, originFlow: string): ReduxThunkAction =>
        async (dispatch, getState) => {
            dispatch(mainSlice.actions.updateState({ status: true }));

            // const serverUrl = process.env.NEXT_PUBLIC_BACK_HOST

            try {
                let token = localStorage.getItem("authToken");

                if (!token) {
                    return;
                }

                const headers = {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                    page: `${page}`,
                    size: `${limit}`,
                    originFlow,
                };

                const response = await fetch(
                    `${serverUrl}/api/shared/getTasksPaginatedByOriginFlow`,
                    {
                        method: "GET",
                        headers,
                    }
                );

                if (response?.status === 401 && allowLogOut) {
                    localStorage.removeItem("authToken");
                    dispatch(
                        mainSlice.actions.addToastNotification({
                            id: `${mainSlice.actions.addToastNotification.length + 1
                                }`,
                            message:
                                "Token ha expirado, por favor inicia sesión nuevamente",
                            type: "error",
                            duration: 5000,
                        })
                    );
                    dispatch(mainSlice.actions.activeUser());
                    return;
                }

                if (response?.status !== 200 && response?.status !== 201) {
                    console.log("Error");
                }

                const data = await response.json();

                dispatch(gerenciaTecnicaSlice.actions.setTasksList(data));
            } catch (error) {
                console.log({ error });
            } finally {
                dispatch(mainSlice.actions.updateState({ status: false }));
            }
        };

export const getReportsList =
    (): ReduxThunkAction => async (dispatch, getState) => {
        dispatch(mainSlice.actions.updateState({ status: true }));

        try {
            let token = localStorage.getItem("authToken");

            if (!token) {
                return;
            }

            const headers = {
                "Content-Type": "application/json",
                authorization: `${token}`,
            };

            const response = await fetch(
                `${serverUrl}/api/reports/listOfEnabledReports`,
                {
                    method: "GET",
                    headers,
                }
            );

            if (response?.status === 401 && allowLogOut) {
                localStorage.removeItem("authToken");
                dispatch(
                    mainSlice.actions.addToastNotification({
                        id: `${mainSlice.actions.addToastNotification.length + 1
                            }`,
                        message:
                            "Token ha expirado, por favor inicia sesión nuevamente",
                        type: "error",
                        duration: 5000,
                    })
                );
                dispatch(mainSlice.actions.activeUser());
                return;
            }

            if (response?.status !== 200 && response?.status !== 201) {
                console.log("Error");
            }

            const data = await response.json();

            dispatch(gerenciaTecnicaSlice.actions.setReportsList(data));
            return data;
        } catch (error) {
            console.log({ error });
        } finally {
            dispatch(mainSlice.actions.updateState({ status: false }));
        }
    };

export const downloadFileReport =
    (fromDate: string, toDate: string): ReduxThunkAction =>
        async (dispatch, getState) => {
            dispatch(mainSlice.actions.updateState({ status: true }));

            try {
                let token = localStorage.getItem("authToken");

                if (!token) {
                    return;
                }

                const headers = {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                    fromDate,
                    toDate,
                    departmentId: `${getState().main.activeDepartmentId}`,
                    projectId: `${getState().main.activeProjectId}`,
                };

                const response = await fetch(
                    `${serverUrl}/api/tasks/getReportsByDate`,
                    {
                        method: "GET",
                        headers,
                    }
                );

                if (response?.status === 401 && allowLogOut) {
                    localStorage.removeItem("authToken");
                    dispatch(
                        mainSlice.actions.addToastNotification({
                            id: `${mainSlice.actions.addToastNotification.length + 1
                                }`,
                            message:
                                "Token ha expirado, por favor inicia sesión nuevamente",
                            type: "error",
                            duration: 5000,
                        })
                    );
                    dispatch(mainSlice.actions.activeUser());
                    return;
                }

                if (response?.status !== 200 && response?.status !== 201) {
                    dispatch(
                        mainSlice.actions.addToastNotification({
                            id: `${mainSlice.actions.addToastNotification.length + 1
                                }`,
                            message: "No se pudo generar el reporte",
                            type: "error",
                            duration: 5000,
                        })
                    );
                } else {
                    const data = await response.json();
                    dispatch(
                        mainSlice.actions.addToastNotification({
                            id: `${mainSlice.actions.addToastNotification.length + 1
                                }`,
                            message: data?.message,
                            type: "success",
                            duration: 5000,
                        })
                    );
                }
            } catch (error) {
                console.log({ error });
            } finally {
                dispatch(mainSlice.actions.updateState({ status: false }));
            }
        };

export const getDataForAnalyst =
    (fromDate: string, toDate: string): ReduxThunkAction =>
        async (dispatch, getState) => {
            dispatch(mainSlice.actions.updateState({ status: true }));

            try {
                let token = localStorage.getItem("authToken");

                if (!token) {
                    return;
                }

                const headers = {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                    fromDate,
                    toDate,
                    departmentId: `${getState().main.activeDepartmentId}`,
                    projectId: `${getState().main.activeProjectId}`,
                };

                const response = await fetch(
                    `${serverUrl}/api/workflow/GetActivitiesWithCards`,
                    {
                        method: "GET",
                        headers,
                    }
                );

                if (response?.status === 401 && allowLogOut) {
                    localStorage.removeItem("authToken");
                    dispatch(
                        mainSlice.actions.addToastNotification({
                            id: `${mainSlice.actions.addToastNotification.length + 1
                                }`,
                            message:
                                "Token ha expirado, por favor inicia sesión nuevamente",
                            type: "error",
                            duration: 5000,
                        })
                    );
                    dispatch(mainSlice.actions.activeUser());
                    return;
                }

                if (response?.status !== 200 && response?.status !== 201) {
                    dispatch(
                        mainSlice.actions.addToastNotification({
                            id: `${mainSlice.actions.addToastNotification.length + 1
                                }`,
                            message: "Error bajando Data",
                            type: "error",
                            duration: 5000,
                        })
                    );
                } else {
                    const listOfLocations: ListOfLocationsToAnalyst[] = [];

                    const data = await response.json();

                    const sortData = data.sort((a: any, b: any) => {
                        return (
                            new Date(a.createdAt).getTime() -
                            new Date(b.createdAt).getTime()
                        );
                    });

                    for (const actSort of sortData) {
                        const exist = listOfLocations.findIndex(
                            (x) => x.id === actSort?.location?.id
                        );

                        const opeStatus = actSort?.variablesValues?.find(
                            (x: any) =>
                                x.typeVariable.id ===
                                "b75159f7-752a-11ef-9499-9c6b00614d7d"
                        )?.value;
                        const activityType = actSort?.variablesValues?.find(
                            (x: any) =>
                                x.typeVariable.id ===
                                "b75159dc-752a-11ef-9499-9c6b00614d7d"
                        )?.value;
                        const cardPath = actSort?.variablesValues?.find(
                            (x: any) =>
                                x.typeVariable.id ===
                                "48eaf472-753e-11ef-9499-9c6b00614d7d"
                        )?.value;

                        if (exist > -1) {
                            listOfLocations[exist].activities.push({
                                id: actSort.id,
                                location: actSort?.location?.name,
                                status: actSort?.process,
                                completedAt: actSort?.createdAt,
                                activityType,
                                opeStatus,
                                cardPath,
                            });
                            if (cardPath) {
                                listOfLocations[exist].hasCardsToAnalyze = true;
                            }
                        } else {
                            listOfLocations.push({
                                id: actSort?.location?.id,
                                name: actSort?.location?.name,
                                status: actSort?.process,
                                completedAt: actSort?.createdAt,
                                pot: actSort?.location?.pot,
                                activityType,
                                opeStatus,
                                hasCardsToAnalyze: cardPath ? true : false,
                                activities: [
                                    {
                                        id: actSort.id,
                                        location: actSort?.location?.name,
                                        status: actSort?.process,
                                        completedAt: actSort?.createdAt,
                                        activityType,
                                        opeStatus,
                                        cardPath,
                                    },
                                ],
                            });
                        }
                    }

                    dispatch(mainSlice.actions.setListOfLocationToAnalyst(listOfLocations));
                }
            } catch (error) {
                console.log({ error });
            } finally {
                dispatch(mainSlice.actions.updateState({ status: false }));
            }
        };

export const downloadExcelConsolidatedFile =
    (field: string): ReduxThunkAction =>
        async (dispatch, getState) => {
            await generateExcelFile(
                getState().gerenciaTecnica?.activitiesWithCarts || [],
                field
            );
        };

export const consolidateFilesLocal =
    (
        filesExcel: FileCustom[],
        filesEchometer: FileCustom[],
        filesSiam: FileCustom[],
        originFlow: string
    ): ReduxThunkAction =>
        async (dispatch, getState) => {
            dispatch(mainSlice.actions.updateState({ status: true }));

            let activeTaskId = "Nueva Tarea";

            let validationVariables = [];

            let locations = [];

            let users = [];

            try {
                if (originFlow) {
                    let token = localStorage.getItem("authToken");

                    const response = await fetch(
                        `${serverUrl}/api/shared/validate-task-by-origin-flow`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                authorization: `${token}`,
                                originFlow,
                            },
                        }
                    );

                    if (response?.status === 401 && allowLogOut) {
                        localStorage.removeItem("authToken");
                        dispatch(
                            mainSlice.actions.addToastNotification({
                                id: `${mainSlice.actions.addToastNotification.length +
                                    1
                                    }`,
                                message:
                                    "Token ha expirado, por favor inicia sesión nuevamente",
                                type: "error",
                                duration: 5000,
                            })
                        );
                        dispatch(mainSlice.actions.activeUser());
                        return;
                    }

                    if (response?.status !== 200 && response?.status !== 201) {
                        console.log("Error");
                        dispatch(
                            mainSlice.actions.setUploadingStep(
                                "Error getting active task"
                            )
                        );
                        return;
                    }

                    const activeTask = await response.json();

                    if (activeTask.length > 0) {
                        activeTaskId = activeTask[0].id;
                    }

                    // get Variables Validation

                    if (
                        !getState().gerenciaTecnica.taskValidations ||
                        (getState().gerenciaTecnica.taskValidations ?? [])
                            .length === 0
                    ) {
                        const response2 = await fetch(
                            `${serverUrl}/api/configuration/origin-flow-variables-with-relations`,
                            {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                    authorization: `${token}`,
                                    originFlow,
                                },
                            }
                        );

                        if (response2?.status !== 200 && response?.status !== 201) {
                            console.log("Error");
                            dispatch(
                                mainSlice.actions.setUploadingStep(
                                    "Error getting validations"
                                )
                            );
                            return;
                        }

                        validationVariables = await response2.json();

                        dispatch(
                            gerenciaTecnicaSlice.actions.setTaskValidations(
                                validationVariables
                            )
                        );
                    }

                    // get users
                    if (
                        !getState().gerenciaTecnica?.users ||
                        (getState().gerenciaTecnica.users ?? []).length === 0
                    ) {
                        const responseGetUsers = await fetch(
                            `${serverUrl}/api/shared/listOfUsers`,
                            {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                    authorization: `${token}`,
                                },
                            }
                        );

                        if (responseGetUsers?.status === 401) {
                            localStorage.removeItem("authToken");
                            dispatch(mainSlice.actions.activeUser());
                            return;
                        }

                        if (
                            responseGetUsers?.status !== 200 &&
                            responseGetUsers?.status !== 201
                        ) {
                            console.log("Error");
                            dispatch(
                                mainSlice.actions.setUploadingStep(
                                    "Error getting Users"
                                )
                            );
                            return;
                        }

                        users = await responseGetUsers.json();

                        dispatch(gerenciaTecnicaSlice.actions.setUsers(users));
                    }

                    // get locations
                    if (
                        !getState().gerenciaTecnica?.locations ||
                        (getState().gerenciaTecnica.locations ?? []).length === 0
                    ) {
                        //////
                        const responseGetLocations = await fetch(
                            `${serverUrl}/api/projects/getLocations`,
                            {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                    authorization: `${token}`,
                                },
                            }
                        );

                        if (
                            responseGetLocations?.status !== 200 &&
                            response?.status !== 201
                        ) {
                            console.log("Error");
                            dispatch(
                                mainSlice.actions.setUploadingStep(
                                    "Error getting Locations"
                                )
                            );
                            return;
                        }

                        locations = await responseGetLocations.json();
                        dispatch(
                            gerenciaTecnicaSlice.actions.setLocations(locations)
                        );
                    }
                }
            } catch (error) {
                console.log({ error });
            }

            let activities: any[] = [];

            let carts: any[] = [];

            if (filesExcel.length > 0) {
                activities = await readExcelFile(filesExcel);
            }

            if (filesEchometer.length > 0) {
                const cartsEchometer = await readEchometerFile(filesEchometer);
                carts = [...carts, ...cartsEchometer];
            }

            if (filesSiam.length > 0) {
                const cartsSiam = await readSiamFile(filesSiam);
                carts = [...carts, ...cartsSiam];
            }

            let activitiesWithCarts = activities.map((act: any) => {
                let dynCarts = carts.filter(
                    (cart: any) => cart.location === act["Pozo"]
                );

                return {
                    ...act,
                    dynCarts: JSON.stringify(dynCarts),
                    haveCart: dynCarts?.length > 0 ? true : false,
                    taskId: activeTaskId,
                    originFlow,
                };
            });

            dispatch(
                gerenciaTecnicaSlice.actions.setActivitiesWithCarts(
                    activitiesWithCarts
                )
            );

            let cardsWithActivities = carts.map((cart: any) => {
                const act = activities.find(
                    (act: any) => act["Pozo"] === cart.location
                );
                return {
                    ...cart,
                    ...act,
                    haveActivity: act ? true : false,
                    taskId: activeTaskId,
                };
            });

            dispatch(
                gerenciaTecnicaSlice.actions.setCardsWithActivities(
                    cardsWithActivities
                )
            );

            dispatch(mainSlice.actions.updateState({ status: false }));
        };

export const getLocations =
    (force = false): ReduxThunkAction => async (dispatch, getState) => {
        try {
            let token = localStorage.getItem("authToken");

            if (!token) {
                return;
            }

            dispatch(mainSlice.actions.updateState({ status: true }));

            const headers = {
                "Content-Type": "application/json",
                authorization: `${token}`,
                originFlowsIds: '5929f816-89c5-4828-9ea3-4ff54be008e3,63624ddd-41c7-45df-8d12-805eb644268c,a6da0d56-ca00-11ef-9bba-712c8b335d3b'
            };

            if (
                !getState().gerenciaTecnica?.locations ||
                (getState().gerenciaTecnica.locations ?? []).length === 0
                || force
            ) {
                const responseGetLocations = await fetch(
                    `${serverUrl}/api/projects/getLocationsWithActivities`,
                    {
                        method: "GET",
                        headers,
                    }
                );

                const locations = await responseGetLocations.json();

                dispatch(gerenciaTecnicaSlice.actions.setLocationsWithData(locations));
            }
        } catch (error) {
            console.log("ERROR", error);
        } finally {
            dispatch(mainSlice.actions.updateState({ status: false }));
        }
    };

export const getLocationsSimpleList =
    (force = false): ReduxThunkAction => async (dispatch, getState) => {
        try {
            let token = localStorage.getItem("authToken");

            if (!token) {
                return;
            }

            dispatch(mainSlice.actions.updateState({ status: true }));

            if (
                !getState().gerenciaTecnica?.locations ||
                (getState().gerenciaTecnica.locations ?? []).length === 0
            ) {
                const responseGetLocations = await fetch(
                    `${serverUrl}/api/projects/getLocations`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `${token}`,
                        },
                    }
                );

                if (
                    responseGetLocations?.status !== 200
                ) {
                    console.log("Error");
                    dispatch(
                        mainSlice.actions.setUploadingStep(
                            "Error getting Locations"
                        )
                    );
                    return;
                }

                const locations = await responseGetLocations.json();
                dispatch(
                    gerenciaTecnicaSlice.actions.setLocations(locations)
                );
            }
        } catch (error) {
            console.log("ERROR", error);
        } finally {
            dispatch(mainSlice.actions.updateState({ status: false }));
        }
    };

export const uploadConsolidatedActivities =
    (sortActivities: any[], executedDate: any): ReduxThunkAction =>
        async (dispatch, getState) => {
            dispatch(mainSlice.actions.setUploadingStep("Uploading"));

            try {
                let token = localStorage.getItem("authToken");

                const stringDate = formatDateWithoutTimeZone(executedDate);

                const originFlowId = sortActivities[0].originFlowId;

                const batchSize = 100;

                for (let i = 0; i < sortActivities.length; i += batchSize) {
                    const batch = sortActivities.slice(i, i + batchSize);
                    try {
                        const activitiesToUpload = batch.map((act: any) => {
                            return {
                                ...act,
                                taskId: "",
                                executedDate: stringDate,
                            };
                        });

                        const activityResponse = await fetch(
                            `${serverUrl}/api/operations/addFieldActivity`,
                            {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    authorization: `${token}`,
                                },
                                body: JSON.stringify(activitiesToUpload),
                            }
                        );

                        const activity = await activityResponse.json();

                        if (activity?.errors) {
                            const errors = activity?.errors.filter((e: any) => e.type === "error")
                            if (errors.length > 0) {
                                throw new Error("Error al subir las actividades favor reintentar");
                            }
                        }

                        if (activityResponse?.status === 401 && allowLogOut) {
                            localStorage.removeItem("authToken");
                            dispatch(
                                mainSlice.actions.addToastNotification({
                                    id: `${mainSlice.actions.addToastNotification
                                        .length + 1
                                        }`,
                                    message:
                                        "Token ha expirado, por favor inicia sesión nuevamente",
                                    type: "error",
                                    duration: 5000,
                                })
                            );
                            dispatch(mainSlice.actions.activeUser());
                            return;
                        }
                    } catch (error) {
                        console.error("Error posting batch:", error);

                        throw new Error("Error al subir las actividades favor reintentar");
                    }
                }

                dispatch(mainSlice.actions.setUploadingStep("Task Uploaded"));
            } catch (error) {
                dispatch(mainSlice.actions.setUploadingStep("Error Uploading"));
            }
        };

export const getReportWithData =
    (
        reportId: string,
        reportCode: string,
        startDate: Date | string,
        endDate: Date | string,
        projectId: string
    ): ReduxThunkAction =>
        async (dispatch, getState) => {
            dispatch(mainSlice.actions.updateState({ status: true }));

            try {
                let token = localStorage.getItem("authToken");

                if (!token) {
                    return;
                }

                const headers = {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                    report_id: reportId,
                    report_code: reportCode,
                    start_date: formatDateToYYYYMMDD(startDate),
                    end_date: formatDateToYYYYMMDD(endDate),
                    project_id: projectId,
                };

                const response = await fetch(
                    `${serverUrl}/api/reports/getReportWithData`,
                    {
                        method: "GET",
                        headers,
                    }
                );

                if (response?.status === 401 && allowLogOut) {
                    dispatch(
                        mainSlice.actions.addToastNotification({
                            id: `${mainSlice.actions.addToastNotification.length + 1
                                }`,
                            message:
                                "Token ha expirado, por favor inicia sesión nuevamente",
                            type: "error",
                            duration: 5000,
                        })
                    );
                    localStorage.removeItem("authToken");
                    dispatch(mainSlice.actions.activeUser());
                    return;
                }

                if (response?.status !== 200 && response?.status !== 201) {
                    return;
                }

                const data = await response.json();

                dispatch(gerenciaTecnicaSlice.actions.setReportData(data));
            } catch (error) {
                console.log({ error });
            } finally {
                dispatch(mainSlice.actions.updateState({ status: false }));
            }
        };

export const sharedReport =
    (
        reportId: string,
        reportCode: string,
        startDate: Date,
        endDate: Date,
        projectId: string,
        email: string[],
        sendEmail: boolean,
        download: boolean
    ): ReduxThunkAction =>
        async (dispatch, getState) => {
            dispatch(mainSlice.actions.updateState({ status: true }));

            try {
                let token = localStorage.getItem("authToken");

                if (!token) {
                    return;
                }

                if (!download && !sendEmail) {
                    dispatch(
                        mainSlice.actions.addToastNotification({
                            id: `${mainSlice.actions.addToastNotification.length + 1
                                }`,
                            message:
                                "Debes seleccionar al menos una opción para compartir el reporte",
                            type: "error",
                            duration: 5000,
                        })
                    );
                    return;
                }

                const headers = {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                    report_id: reportId,
                    report_code: reportCode,
                    start_date: formatDateToYYYYMMDD(startDate),
                    end_date: formatDateToYYYYMMDD(endDate),
                    project_id: projectId,
                    emails_to_shared: JSON.stringify(email),
                    sendEmail: sendEmail.toString(),
                    download: download.toString(),
                };

                const response = await fetch(
                    `${serverUrl}/api/reports/shareReport`,
                    {
                        method: "GET",
                        headers,
                    }
                );

                if (response?.status === 401 && allowLogOut) {
                    localStorage.removeItem("authToken");
                    dispatch(
                        mainSlice.actions.addToastNotification({
                            id: `${mainSlice.actions.addToastNotification.length + 1
                                }`,
                            message:
                                "Token ha expirado, por favor inicia sesión nuevamente",
                            type: "error",
                            duration: 5000,
                        })
                    );
                    dispatch(mainSlice.actions.activeUser());
                    return;
                }

                if (response?.status !== 200 && response?.status !== 201) {
                    dispatch(
                        mainSlice.actions.addToastNotification({
                            id: `${mainSlice.actions.addToastNotification.length + 1
                                }`,
                            message:
                                "No se podido enviar el reporte al correo, intentalo luego",
                            type: "error",
                            duration: 5000,
                        })
                    );
                } else {
                    if (sendEmail) {
                        dispatch(
                            mainSlice.actions.addToastNotification({
                                id: `${mainSlice.actions.addToastNotification.length +
                                    1
                                    }`,
                                message:
                                    "Se ha programado el envio del reporte al correo",
                                type: "success",
                                duration: 5000,
                            })
                        );
                    }

                    if (response?.status !== 200 && response?.status !== 201) {
                        dispatch(
                            mainSlice.actions.addToastNotification({
                                id: `${mainSlice.actions.addToastNotification.length +
                                    1
                                    }`,
                                message:
                                    "No se podido enviar el reporte al correo, intentalo luego",
                                type: "error",
                                duration: 5000,
                            })
                        );
                    } else {
                        if (sendEmail) {
                            dispatch(
                                mainSlice.actions.addToastNotification({
                                    id: `${mainSlice.actions.addToastNotification
                                        .length + 1
                                        }`,
                                    message:
                                        "Se ha programado el envio del reporte al correo",
                                    type: "success",
                                    duration: 5000,
                                })
                            );
                        }

                        if (response.ok && download) {
                            const blob = await response.blob();
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement("a");
                            a.href = url;


                            const contentDisposition = response.headers.get(
                                "Content-Disposition"
                            );

                            if (contentDisposition) {
                                a.download =
                                    contentDisposition.split("filename=")[1];
                            }
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                            window.URL.revokeObjectURL(url);
                        }
                    }
                }
            } catch (error) {
                console.log({ error });
            } finally {
                dispatch(mainSlice.actions.updateState({ status: false }));
            }
        };

export const getDailyReport =
    (
        reportId: string,
        reportCode: string,
        startDate: Date | string,
        endDate: Date | string,
        projectId: string
    ): ReduxThunkAction =>
        async (dispatch, getState) => {
            dispatch(mainSlice.actions.updateState({ status: true }));

            try {
                let token = localStorage.getItem("authToken");

                if (!token) {
                    return;
                }

                const headers = {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                    report_id: reportId,
                    report_code: reportCode,
                    start_date: formatDateToYYYYMMDD(startDate),
                    end_date: formatDateToYYYYMMDD(endDate),
                    project_id: projectId,
                };

                const response = await fetch(
                    `${serverUrl}/api/reports/getDailyReport`,
                    {
                        method: "GET",
                        headers,
                    }
                );

                if (response?.status === 401 && allowLogOut) {
                    dispatch(
                        mainSlice.actions.addToastNotification({
                            id: `${mainSlice.actions.addToastNotification.length + 1
                                }`,
                            message:
                                "Token ha expirado, por favor inicia sesión nuevamente",
                            type: "error",
                            duration: 5000,
                        })
                    );
                    localStorage.removeItem("authToken");
                    dispatch(mainSlice.actions.activeUser());
                    return;
                }

                if (response?.status !== 200 && response?.status !== 201) {
                    return;
                }

                const data = await response.json();

                dispatch(gerenciaTecnicaSlice.actions.setReportData(data));
            } catch (error) {
                console.log({ error });
            } finally {
                dispatch(mainSlice.actions.updateState({ status: false }));
            }
        };
